import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from 'nuqs'

import {
  SelectableColumns,
  selectableColumns,
} from '../components/ColumnsFilter'

export const useSelectedColumnsQueryState = () => {
  const selectedColumnsParser = parseAsStringLiteral(
    selectableColumns.map((column) => column.id)
  )

  const queryStates = useQueryState(
    'selected-columns',
    parseAsArrayOf<SelectableColumns>(selectedColumnsParser).withDefault([
      'user',
      'provider',
      'originated-at',
      'comment',
    ])
  )

  return queryStates
}
